/**
 * @fileoverview gRPC-Web generated client stub for reconpb
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v2.0.2
// 	protoc              v0.0.0
// source: reconpb/executionrecon.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_type_date_pb = require('../google/type/date_pb.js')
const proto = {};
proto.reconpb = require('./executionrecon_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.reconpb.ExecutionReconServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.reconpb.ExecutionReconServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.reconpb.ListExecutionReconRequest,
 *   !proto.reconpb.ListExecutionReconResponse>}
 */
const methodDescriptor_ExecutionReconService_ListExecutionRecon = new grpc.web.MethodDescriptor(
  '/reconpb.ExecutionReconService/ListExecutionRecon',
  grpc.web.MethodType.UNARY,
  proto.reconpb.ListExecutionReconRequest,
  proto.reconpb.ListExecutionReconResponse,
  /**
   * @param {!proto.reconpb.ListExecutionReconRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.reconpb.ListExecutionReconResponse.deserializeBinary
);


/**
 * @param {!proto.reconpb.ListExecutionReconRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.reconpb.ListExecutionReconResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.reconpb.ListExecutionReconResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.reconpb.ExecutionReconServiceClient.prototype.listExecutionRecon =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/reconpb.ExecutionReconService/ListExecutionRecon',
      request,
      metadata || {},
      methodDescriptor_ExecutionReconService_ListExecutionRecon,
      callback);
};


/**
 * @param {!proto.reconpb.ListExecutionReconRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.reconpb.ListExecutionReconResponse>}
 *     Promise that resolves to the response
 */
proto.reconpb.ExecutionReconServicePromiseClient.prototype.listExecutionRecon =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/reconpb.ExecutionReconService/ListExecutionRecon',
      request,
      metadata || {},
      methodDescriptor_ExecutionReconService_ListExecutionRecon);
};


module.exports = proto.reconpb;

